import * as React from 'react';
import LogoAsset from '../assets/logo.png';
import AppUtils from '../utils/AppUtils';

export default class Logo extends React.Component<any, any> {
    
    constructor(props:any) {
        super(props);
    }

    render() {
        return (
            <div id='SLGLogo'>
            {
                AppUtils.isMobile == false ?
                <a href="http://www.adeptly.ai"><img src={LogoAsset} alt='Powered by adeptly.ai'/></a>
                : null
            }
            </div>
            // <a id='SLGLogo' href="http://www.SeriousLearningGames.com"><img src={LogoAsset} alt='Created by SeriousLearningGames.com'/></a>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Logo.tsx